//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { mapState,mapMutations } from 'vuex'
	export default{
		name:'rightcolumn',
		data(){
			return{
				
			}
		},
		created() {
			/*if(sessionStorage.getItem('egg_token')){
				this.set_reg_show(JSON.parse(sessionStorage.getItem('already')))
				this.get_user()
				this.set_login_status(true)
			}
			this.getserviceinfo()
			this.getregisterStatus()*/
		},
		methods:{
			...mapMutations,
			//登录注册弹窗
			set_logout(){
				this.$store.commit('set_logpopShow', true)
			},
			//充值
			torecharge(){
				if(sessionStorage.getItem('egg_token')){
					this.set_frontShow(true)
				}else{
					this.set_logoutdata({
						show:true,
						entrance:'Sign'
					})
				}
			},
			//客服信息
			getserviceinfo() {
				serviceinfo().then((res) => {
					this.serviceInfo = res.data
				})
			},
			//注册红包开关
			getregisterStatus() {
				registerStatus().then(res => {
					if (res.data.success) {
						this.three = true
					}
				})
			},
			//领取注册红包
			// todoRegister() {
			// 	if (sessionStorage.getItem('egg_token')) {
			// 		if(this.three && !this.reg_show){
			// 			this.registerRed()
			// 		}else{
			// 			this.set_redShow(true)
			// 		}
			// 	}else{
			// 		this.set_logoutdata({
			// 			show: true,
			// 			entrance: 'Sign'
			// 		})
			// 	}
			// },
			
			//注册红包
			registerRed(){
				doRegister().then(res => {
					if (res.data.data !== 0) {
						this.set_receiveInfo({
							show:true,
							counter:res.data.data,
							category:''
						})
						this.set_reg_show(true)
						sessionStorage.setItem('already',true)
						this.get_user()
						this.getregisterStatus()
						this.set_redShow(true)
					} else {
						this.message('您已领取过注册红包')
					}
				})
			},
			
			//背包
			toknapsack() {

				if(this.user.nickname){
					this.$router.push('/official/warehouse')
				}
				else{
					this.set_logout()
				}
			},
			
			//群聊
			// chat() {
			// 	if (sessionStorage.getItem('egg_token')) {
			// 		window.open("https://jq.qq.com/?_wv=1027&k=S9Psd4mj")
			// 	} else {
			// 		this.set_logoutdata({
			// 			show: true,
			// 			entrance: 'Sign'
			// 		})
			// 	}
			// },
			
			//客服
			// awaken_QQ() {
			// 	if (sessionStorage.getItem('egg_token')) {
			// 		window.open("http://wpa.qq.com/msgrd?v=3&uin=" + this.serviceInfo.qqOne + "&site=qq&menu=yes")
			// 	} else {
			// 		this.set_logoutdata({
			// 			show: true,
			// 			entrance: 'Sign'
			// 		})
			// 	}
			// },
			
			
			
			//跨站跳转
			station(path){
				if(sessionStorage.getItem('renew')){
					let list = JSON.parse(sessionStorage.getItem('renew'))
					if(list.length > 0){
						this.set_messageData({
							show:true,
							text:'库存中还有新饰品刮刮乐<br/>确定切换风格吗？',
							path:path
						})
					}else{
						this.set_messageData({
							show:true,
							text:'<br/>进入页面将切换至egg风格',
							path:path
						})	
					}
				}else{
					this.set_messageData({
						show:true,
						text:'<br/>进入页面将切换至egg风格',
						path:path
					})
				}
			}
		},
		computed:{
			...mapState(['user','reg_show','scrape'])
		},
	}
